"use client";
import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import useWebVisit from "@/app/lib/features/webVisit/webVisit.hook";
import {
  extractTrackingData,
  markLoggedInSession,
  shouldLogWebVisit,
} from "@/app/utils/webVisit.utils";

const WebVisitLoggerProvider = () => {
  const searchParams = useSearchParams();
  const { logged, logVisit } = useWebVisit();

  useEffect(() => {
    const referrer =
      typeof document !== "undefined" ? document.referrer : "";
    
    const trackingData = extractTrackingData(searchParams);

    if (!shouldLogWebVisit(logged, trackingData, referrer)) {
      return;
    }

    const payload = {
      ...trackingData,
      referrer,
      url: typeof window !== "undefined" ? window.location.href : "",
    };

    logVisit(payload);
    markLoggedInSession();
  }, [logged, logVisit, searchParams]);

  return null;
};

export default WebVisitLoggerProvider;